import React, { useState } from "react";

const Swipeable = ({ children, onSwipeLeft, onSwipeRight }) => {
  const [startX, setStartX] = useState(null);
  const [endX, setEndX] = useState(null);

  const handleTouchStart = (event) => {
    setStartX(event.touches[0].clientX);
  };

  const handleTouchMove = (event) => {
    setEndX(event.touches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (startX && endX) {
      const diffX = endX - startX;
      if (Math.abs(diffX) > 200) {
        if (diffX > 0 && onSwipeRight) {
          onSwipeRight();
          vibrateDevice();
        } else if (diffX < 0 && onSwipeLeft) {
          onSwipeLeft();
          vibrateDevice();
        }
      }
    }
    setStartX(null);
    setEndX(null);
  };

  const vibrateDevice = () => {
    if (navigator.vibrate) {
      navigator.vibrate(50);
    }
  };

  return (
    <div
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      style={{ width: "100%", height: "100%" }}
    >
      {children}
    </div>
  );
};

export default Swipeable;
